import settlementsSummary from './SettlementsSummary/settlementsSummaryStore';
import chargeDetails from './SettlementsChargeDetails/settlementsChargeDetailsStore';
import determinantDetails from './DeterminantDetails/determinantDetailsStore';
import bdOverrides from './BDOverrides/bdOverridesStore';
import invoiceDetails from './invoiceDetails/invoiceDetailsStore';

export default {
  namespaced: true,
  modules: {
    settlementsSummary,
    chargeDetails,
    determinantDetails,
    bdOverrides,
    invoiceDetails,
  },
};